import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { CustomerCommentsModel } from '../models/customer-comments.model';

export class CustomersCommentsApiService extends ApiService {
  static endpoint = 'customers/{customerId}/comments';

  /**
   * @param {String} orderId
   * @param {Number|null} id
   * @return {String}
   * @protected
   */
  static buildCustomerCommentsUrl(orderId, id = null) {
    return this.buildUrl(id).replace('{customerId}', orderId);
  }

  /**
   * @param {String} customerId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CustomerCommentsModel>>}
   * @public
   */
  static async getAll(customerId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildCustomerCommentsUrl(customerId), {
      ...config,
      dataModel: CustomerCommentsModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String} customerId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CustomerCommentsModel>>}
   * @public
   */
  static async post(customerId, data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildCustomerCommentsUrl(customerId), data, {
      ...config,
      dataModel: CustomerCommentsModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
